import * as util from "../core/util.js";
const error = () => {
    const Sizable = {
        string: { unit: "অক্ষর", verb: "থাকতে হবে" },
        file: { unit: "বাইট", verb: "থাকতে হবে" },
        array: { unit: "আইটেম", verb: "থাকতে হবে" },
        set: { unit: "আইটেম", verb: "থাকতে হবে" },
        map: { unit: "এন্ট্রি", verb: "থাকতে হবে" },
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "ইনপুট",
        email: "ইমেইল ঠিকানা",
        url: "URL",
        emoji: "ইমোজি",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO তারিখ ও সময়",
        date: "ISO তারিখ",
        time: "ISO সময়",
        duration: "ISO সময়কাল",
        ipv4: "IPv4 ঠিকানা",
        ipv6: "IPv6 ঠিকানা",
        mac: "MAC ঠিকানা",
        cidrv4: "IPv4 রেঞ্জ",
        cidrv6: "IPv6 রেঞ্জ",
        base64: "base64-এনকোডেড স্ট্রিং",
        base64url: "base64url-এনকোডেড স্ট্রিং",
        json_string: "JSON স্ট্রিং",
        e164: "E.164 নম্বর",
        credit_card: "ক্রেডিট কার্ড নম্বর",
        jwt: "JWT",
        template_literal: "ইনপুট",
    };
    const TypeDictionary = {
        nan: "NaN",
    };
    return (issue) => {
        switch (issue.code) {
            case "invalid_type": {
                const expected = TypeDictionary[issue.expected] ?? issue.expected;
                const receivedType = util.parsedType(issue.input);
                const received = TypeDictionary[receivedType] ?? receivedType;
                return `অবৈধ ইনপুট: প্রত্যাশিত ${expected}, প্রাপ্ত ${received}`;
            }
            case "invalid_value":
                if (issue.values.length === 1)
                    return `অবৈধ ইনপুট: প্রত্যাশিত ${util.stringifyPrimitive(issue.values[0])}`;
                return `অবৈধ অপশন: ${util.joinValues(issue.values, " | ")} এর মধ্যে একটি প্রত্যাশিত`;
            case "too_big": {
                const adj = issue.inclusive ? "<=" : "<";
                const sizing = getSizing(issue.origin);
                if (sizing)
                    return `অনেক বড়: ${issue.origin ?? "মান"} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "এলিমেন্ট"} হতে হবে`;
                return `অনেক বড়: ${issue.origin ?? "মান"} ${adj}${issue.maximum.toString()} হতে হবে`;
            }
            case "too_small": {
                const adj = issue.inclusive ? ">=" : ">";
                const sizing = getSizing(issue.origin);
                if (sizing) {
                    return `অনেক ছোট: ${issue.origin} ${adj}${issue.minimum.toString()} ${sizing.unit} হতে হবে`;
                }
                return `অনেক ছোট: ${issue.origin} ${adj}${issue.minimum.toString()} হতে হবে`;
            }
            case "invalid_format": {
                const _issue = issue;
                if (_issue.format === "starts_with") {
                    return `অবৈধ স্ট্রিং: "${_issue.prefix}" দিয়ে শুরু হতে হবে`;
                }
                if (_issue.format === "ends_with")
                    return `অবৈধ স্ট্রিং: "${_issue.suffix}" দিয়ে শেষ হতে হবে`;
                if (_issue.format === "includes")
                    return `অবৈধ স্ট্রিং: "${_issue.includes}" অন্তর্ভুক্ত থাকতে হবে`;
                if (_issue.format === "regex")
                    return `অবৈধ স্ট্রিং: ${_issue.pattern} প্যাটার্ন মিলতে হবে`;
                return `অবৈধ ${FormatDictionary[_issue.format] ?? issue.format}`;
            }
            case "not_multiple_of":
                return `অবৈধ নম্বর: ${issue.divisor} এর গুণিতক হতে হবে`;
            case "unrecognized_keys":
                return `অচেনা কী${issue.keys.length > 1 ? "গুলো" : ""}: ${util.joinValues(issue.keys, ", ")}`;
            case "invalid_key":
                return `${issue.origin} এ অবৈধ কী`;
            case "invalid_union":
                if (issue.options && Array.isArray(issue.options) && issue.options.length > 0) {
                    const opts = issue.options.map((o) => `'${o}'`).join(" | ");
                    return `অবৈধ ডিসক্রিমিনেটর মান। প্রত্যাশিত ${opts}`;
                }
                return "অবৈধ ইনপুট";
            case "invalid_element":
                return `${issue.origin} এ অবৈধ মান`;
            default:
                return "অবৈধ ইনপুট";
        }
    };
};
export default function () {
    return {
        localeError: error(),
    };
}
